import { render, staticRenderFns } from "./list-history.vue?vue&type=template&id=1ce70a46"
import script from "./list-history.vue?vue&type=script&lang=js"
export * from "./list-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports